import React from "react";
import Prism from "prismjs";
import "prismjs/themes/prism-tomorrow.css"; // Dark theme
import "prismjs/components/prism-javascript";
import "prismjs/components/prism-jsx";
import "prismjs/components/prism-typescript";
import "prismjs/components/prism-bash";
import "prismjs/components/prism-json";

export function CodeBlock({ children, language }) {
    React.useEffect(() => {
        Prism.highlightAll();
    }, [children]);

    // Map common language identifiers to Prism's language names
    const languageMap = {
        js: "javascript",
        javascript: "javascript",
        jsx: "jsx",
        ts: "typescript",
        typescript: "typescript",
        bash: "bash",
        shell: "bash",
        json: "json",
    };

    const prismLanguage = languageMap[language?.toLowerCase()] || "javascript";

    return (
        <div className="relative rounded-lg bg-gray-100 dark:bg-gray-900 border border-gray-200 dark:border-gray-700">
            {language && (
                <div className="absolute right-4 top-4 text-xs text-gray-600 dark:text-gray-400">
                    {language}
                </div>
            )}
            <div className="overflow-x-auto">
                <pre className="p-4 text-sm min-w-full">
                    <code
                        className={`language-${prismLanguage} whitespace-pre`}
                    >
                        {children}
                    </code>
                </pre>
            </div>
        </div>
    );
}
